import { useContext, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
  InputCheckboxGroup,
  InputCheckbox,
  InputTextField
} from '@abbott-components/core';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlState from '../../Shared/controlState';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import formatName from '../formatName';
import SizingSelect from '../../Shared/SizingSelect';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);
  const { isReadOnlyView } = state;

  const { schema } = control;
  const properties = schema?.properties as JSONSchema7Properties;

  const formContext = useFormContext();
  const timeFormatLabel = formatName(properties['format']?.$id as string);

  const [timeFormat, setTimeFormat] = useState(
    formContext.getValues(timeFormatLabel)
  );

  const handleTimeFormatChange = (event: SelectChangeEvent) => {
    formContext.setValue(timeFormatLabel, event.target.value);
    setTimeFormat(event.target.value);
  };

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['label']?.$id as string)}
            label="Text Label"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['id']?.$id as string)}
            label="ID"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 4, paddingTop: '16px' }}>
          <FormControl disabled={isReadOnlyView}>
            <InputLabel>Time format</InputLabel>
            <Select
              label="Time format"
              value={timeFormat}
              onChange={handleTimeFormatChange}
            >
              <MenuItem value={'12Hrs'}>12 Hrs</MenuItem>
              <MenuItem value={'24Hrs'}>24 Hrs</MenuItem>
            </Select>
          </FormControl>
          <InputTextField
            name={formatName(properties['format']?.$id as string)}
            label="Time format"
            sx={{ display: 'none' }}
          />
        </Stack>
        <SizingSelect
          isReadOnlyView={isReadOnlyView}
          name={formatName(properties['gridSize']?.$id as string)}
        />
      </Stack>

      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 2 }}>
          <InputCheckboxGroup
            name={`${formatName(
              properties['required']?.$id as string
            )}-inputCheckBoxGroup`}
            isDisabled={isReadOnlyView}
          >
            <InputCheckbox
              name={formatName(properties['required']?.$id as string)}
              defaultChecked={
                (properties['required'].default as boolean) ?? false
              }
            >
              Required Field
            </InputCheckbox>
          </InputCheckboxGroup>
        </Stack>
      </Stack>
    </Stack>
  );
};
